import {
  PatientMedication,
  PatientMedicationControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type Params = {
  patientMedication: PatientMedication;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePatientMedicationCreate = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientMedicationControllerApi(
      getConfigObject()
    ).createPatientMedication(params.patientMedication, params.xTENANTID)
  );
